'use client';

import { isFeatureEnabled } from '@/hooks/use-feature-flag';
import { FEATURE_FLAGS } from '@/hooks/use-feature-flag/constants';
import { useSessionValues } from '@/providers/session-provider/hooks/use-session-values';
import { useCustomFunctionalityPermissions } from '@/hooks/use-custom-functionality-permissions';
import { useMemo } from 'react';
import { permittedSearchCollections, searchDescription } from './access';

export function useSearchAccess() {
  const permissions = useCustomFunctionalityPermissions();
  const { customerId, organizationId, userId } = useSessionValues();
  const enabled = isFeatureEnabled(FEATURE_FLAGS.GLOBAL_SEARCH_V2);
  const status = enabled ? permissions.status : 'ready';
  const grants = permissions.grants;
  const collections = useMemo(
    () =>
      enabled && status === 'ready' ? permittedSearchCollections(grants) : [],
    [enabled, status, grants]
  );
  return {
    collections,
    status,
    // Scope cached results to both identity and current collection permissions.
    cacheScope: [customerId, organizationId, userId, enabled, status],
    description:
      status === 'loading'
        ? 'Hämtar sökbehörigheter…'
        : status === 'error'
          ? 'Sökbehörigheterna kunde inte hämtas.'
          : searchDescription(collections),
  };
}
